import { Injectable } from '@angular/core';
import { AppSettingProviderService } from '@services/settings';
import { LocationConfig } from '@techwan/ionic-plugin-location';
import { map, merge, Observable, Subject, Subscription, zip } from 'rxjs';

@Injectable()
export class LocationConfigService {
  private locationConfig: Subject<LocationConfig> = new Subject<LocationConfig>();
  get $change(): Observable<LocationConfig> {
    return this.locationConfig.asObservable();
  }

  private settingsChangeSub: Subscription;

  constructor(private appSettingProvider: AppSettingProviderService) {}

  init(): Observable<LocationConfig> {
    return zip(
      this.appSettingProvider.getLocationTracking(),
      this.appSettingProvider.getLocationTrackingDistanceFilter(),
      this.appSettingProvider.getLocationTrackingUpdateInterval()
    ).pipe(
      map(([locationTrackingEnabled, distanceFilter, updateInterval]) => {
        this.settingsChangeSub = merge(locationTrackingEnabled.$change, distanceFilter.$change, updateInterval.$change).subscribe(() =>
          this.onLocationTrackingSettingChanged(locationTrackingEnabled.current, distanceFilter.current, updateInterval.current)
        );

        return {
          LocationTrackingEnabled: locationTrackingEnabled.current,
          DistanceFilter: distanceFilter.current,
          ServerUpdatePeriod: updateInterval.current
        };
      })
    );
  }

  private onLocationTrackingSettingChanged(locationTrackingEnabled: boolean, distanceFilter: number, updateInterval: number) {
    this.locationConfig.next({
      LocationTrackingEnabled: locationTrackingEnabled,
      DistanceFilter: distanceFilter,
      ServerUpdatePeriod: updateInterval
    });
  }

  uninit() {
    this.settingsChangeSub?.unsubscribe();
  }
}
